import { useReducer } from 'react'
import * as R from 'ramda'

const checkIdDuplicate = (data, checkIds) => {
  const filterData = data.filter((item) => {
    return R.includes(item.id, checkIds)
  })
  return filterData.length === checkIds.length
}

const handleCheckAll = ({ data, checkIds, page, pageSize }) => {
  if (R.isNil(checkIds)) {
    return { isCheckAll: false, indeterminate: false }
  }
  if (
    R.length(data) <= pageSize &&
    R.length(checkIds) === R.length(data) &&
    page === 1 &&
    checkIdDuplicate(data, checkIds)
  ) {
    return { isCheckAll: true, indeterminate: false }
  }

  const lastPage = Math.floor(data.length / pageSize) + 1
  const dataLastPage = data.length - pageSize * (lastPage - 1)

  const dataLengthOfPage = data.filter((item, index) => {
    const lastIndexOfPage = page * pageSize - 1
    const firstIndexOfPage = page * pageSize - pageSize
    if (index < firstIndexOfPage || index > lastIndexOfPage) {
      return false
    }

    return R.isEmpty(checkIds) ? false : R.includes(item.id, checkIds)
  })
  const isCheckAll =
    dataLengthOfPage.length > 0 &&
    (dataLengthOfPage.length === pageSize ||
      (dataLengthOfPage.length === dataLastPage && page === lastPage))

  return {
    isCheckAll,
    indeterminate: !isCheckAll && dataLengthOfPage.length > 0,
  }
}
const initialState = {
  checkedItems: [],
  searchText: '',
  membersList: [],
  pageSize: 10,
  page: 1,
  isCheckAll: false,
  indeterminate: false,
  selectedList: [],
}

const ActionTypes = {
  HANDEL_CHECK_ALL: 'HANDEL_CHECK_ALL',
  SELECTED_ITEM: 'SELECTED_ITEM',
  ON_PAGE_CHANGE: 'ON_PAGE_CHANGE',
  ON_PAGE_SIZE_CHANGE: 'ON_PAGE_SIZE_CHANGE',
  SET_DEFAULT: 'SET_DEFAULT',
  SEARCH_TEXT: 'SEARCH_TEXT',
  SUBMIT_DATA: 'SUBMIT_DATA',
  SET_INITAIL_DATA: 'SET_INITAIL_DATA',
}
const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.HANDEL_CHECK_ALL:
      return {
        ...state,
        checkedItems: action.payload,
        selectedList: R.filter((list) => R.includes(list.id, action.payload))(
          state.membersList,
        ),
        ...handleCheckAll({
          data: state.membersList,
          checkIds: action.payload,
          page: state.page,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.SELECTED_ITEM:
      return {
        ...state,
        checkedItems: action.payload,
        selectedList: R.filter((list) => R.includes(list.id, action.payload))(
          state.membersList,
        ),
        ...handleCheckAll({
          data: state.membersList,
          checkIds: action.payload,
          page: state.page,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.ON_PAGE_CHANGE:
      return {
        ...state,
        page: action.payload,
        ...handleCheckAll({
          data: state.membersList,
          checkIds: state.checkedItems,
          page: action.payload,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.ON_PAGE_SIZE_CHANGE:
      return {
        ...state,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        ...handleCheckAll({
          data: state.membersList,
          checkIds: state.checkedItems,
          page: action.payload.page,
          pageSize: action.payload.pageSize,
        }),
      }
    case ActionTypes.SET_DEFAULT:
      return {
        ...state,
        membersList: action.payload.membersList,
        checkedItems: action.payload.checkIds,
        selectedList: R.filter((list) =>
          R.includes(list.id, action.payload.checkIds),
        )(state.membersList),
        searchText: '',
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: action.payload.membersList,
          checkIds: action.payload.checkIds,
          page: 1,
          pageSize: 10,
        }),
      }
    case ActionTypes.SUBMIT_DATA:
      return {
        ...state,
        membersList: state.membersList,
        checkedItems: action.payload,
        selectedList: R.filter((list) => R.includes(list.id, action.payload))(
          state.membersList,
        ),
        searchText: '',
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: state.membersList,
          checkIds: action.payload,
          page: 1,
          pageSize: 10,
        }),
      }
    case ActionTypes.SEARCH_TEXT:
      return {
        ...state,
        membersList: action.payload.membersList,
        searchText: action.payload.text,
        page: 1,
        pageSize:
          action.payload.text && action.payload.membersList.length <= 10
            ? action.payload.membersList.length
            : 10,
        ...handleCheckAll({
          data: action.payload.membersList,
          checkIds: state.checkedItems,
          page: 1,
          pageSize:
            action.payload.text && action.payload.membersList.length <= 10
              ? action.payload.membersList.length
              : 10,
        }),
      }
    case ActionTypes.SET_INITAIL_DATA:
      return action.payload
    default:
      return state
  }
}
export const useChecked = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const setInitailDate = ({ checkedItems, membersList }) => {
    dispatch({
      type: 'SET_INITAIL_DATA',
      payload: {
        checkedItems: checkedItems || [],
        searchText: '',
        membersList,
        selectedList: [],
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: membersList,
          checkIds: checkedItems,
          page: 1,
          pageSize: 10,
        }),
      },
    })
  }

  const toggleSelectAll = (checked) => {
    const lastIndexOfPage = state.page * state.pageSize - 1
    const firstIndexOfPage = state.page * state.pageSize - state.pageSize
    const listIds = state.membersList
      .filter((item, index) => {
        return index >= firstIndexOfPage && index <= lastIndexOfPage
      })
      .map((item) => item.id)

    const checkedItems = [
      ...new Set(
        checked
          ? [...state.checkedItems, ...listIds]
          : state.checkedItems.filter((item) => {
              return !R.includes(item, listIds)
            }),
      ),
    ]

    dispatch({ type: ActionTypes.HANDEL_CHECK_ALL, payload: checkedItems })
  }

  const toggleSelect = (id) => {
    const checkedItems = state.checkedItems.includes(id)
      ? state.checkedItems.filter((itemId) => itemId !== id)
      : [...state.checkedItems, id]

    dispatch({
      type: ActionTypes.SELECTED_ITEM,
      payload: checkedItems,
    })
  }

  const onPageChange = (page) => {
    dispatch({ type: 'ON_PAGE_CHANGE', payload: page + 1 })
  }

  const onPageSizeChange = (pageSize, pageIndex) => {
    dispatch({
      type: 'ON_PAGE_SIZE_CHANGE',
      payload: { pageSize, page: pageIndex + 1 },
    })
  }

  const onSearchData = ({ text, membersList }) => {
    if (R.isEmpty(text)) {
      dispatch({
        type: 'SEARCH_TEXT',
        payload: { membersList: membersList, text },
      })
    }
    let searchText = text.toLowerCase()
    const words = searchText.split(' ')
    if (words.length > 3) {
      dispatch({
        type: 'SEARCH_TEXT',
        payload: { membersList: [], text },
      })
      return
    }
    const membersListSearch = membersList.filter((subscriber) => {
      // Convert relevant fields and search words to lowercase
      const firstName = (
        subscriber.parentFirstName ?? subscriber.crmInfo.firstName
      ).toLowerCase()
      const lastName = (
        subscriber.parentLastName ?? subscriber.crmInfo.lastName
      ).toLowerCase()
      const crmFirstName = (subscriber.crmInfo.firstName ?? '').toLowerCase()
      const crmLastName = (subscriber.crmInfo.lastName ?? '').toLowerCase()
      const searchWords = words.map((word) => word.toLowerCase())

      switch (searchWords.length) {
        case 1:
          return (
            firstName.includes(searchWords[0]) ||
            lastName.includes(searchWords[0]) ||
            crmFirstName.includes(searchWords[0]) ||
            crmLastName.includes(searchWords[0])
          )

        case 2:
          return (
            (firstName.includes(searchWords[0]) &&
              lastName.includes(searchWords[1])) ||
            (crmFirstName.includes(searchWords[0]) &&
              crmLastName.includes(searchWords[1]))
          )

        case 3:
          return (
            (firstName.includes(searchWords[0]) &&
              lastName.includes(searchWords[2])) ||
            (crmFirstName.includes(searchWords[0]) &&
              crmFirstName.includes(searchWords[1]) &&
              crmLastName.includes(searchWords[2]))
          )

        default:
          return false
      }
    })
    dispatch({
      type: 'SEARCH_TEXT',
      payload: { membersList: membersListSearch, text },
    })
  }

  return {
    state,
    onPageChange,
    onPageSizeChange,
    onSearchData,
    setInitailDate,
    toggleSelect,
    toggleSelectAll,
  }
}
